import { Text } from '@kanda-libs/ks-design-library';
import BulletListHorizontal from 'components/BulletListHorizontal';
import TermsAndConditionsForm from 'components/TermsAndConditionsForm';
import BasePage from '../BasePage';
import { BULLETS } from './constants';

const TermsAndConditions: React.FunctionComponent = function () {
  return (
    <BasePage>
      <div className="flex flex-col max-w-120 md:max-w-full mx-auto">
        <Text
          text="Agree to Ideal4Finance's Terms and Conditions"
          className="mb-2 text-28-32-em text-neutral-900 md:mb-4"
        />
        <Text
          text="To finalise your account with Ideal4Finance, you need to read and agree to Ideal4Finance's terms and conditions below. The person agreeing to and signing the terms and conditions should be able to do so on behalf of the company holding the account."
          className="mb-4 text-12-18 md:text-16-24 text-neutral-700 md:mb-8"
        />
        <BulletListHorizontal bullets={BULLETS} />
        <div className="mb-8" />
        <TermsAndConditionsForm />
      </div>
    </BasePage>
  );
};

export default TermsAndConditions;
